import React from "react";
import {connect} from "react-redux";
import MyTheme from "../../Theme/Theme";
import {
    Alert,
    Animated, Image,
    Platform,
    SafeAreaView,
    ScrollView,
    StyleSheet,
    Text,
    TouchableOpacity,
    View
} from "react-native";
import LogoComplet, {BOLogoComplet} from "../Picto/LogoComplet";
import BoutonText from "../Bouton/BoutonText";
import EffacerPicto from "../Picto/EffacerPicto";
import KeyboardNumber from "../Bouton/KeyboardNumber";
import { CommonActions } from "@react-navigation/native";
import * as Haptics from 'expo-haptics';
import * as Crypto from "expo-crypto";
import {compose} from "redux";
import {withTranslation} from "react-i18next";

import {getSwRegistration} from "../../sw/sw_registration";
import { updateFound } from "../../sw/sw_registration";

class NIPScreen extends React.Component{

    constructor(props) {
        super(props);
        this.isChange = (this.props.route.params===undefined)? false : this.props.route.params.isChange;
        this.state = {
            code : "",
            attemptNIP : 0,
            etapeChangeNIP:0
        }
        this._deconnexion = this._deconnexion.bind(this);
        this._verifNIP = this._verifNIP.bind(this);
        this.setFooter = this.setFooter.bind(this);
        this.shakeAnimation = new Animated.Value(0);
        if(this.props.NIP==null){
            this._sendAlertNewNIP();
        }

        if( this.isChange){
            this._sendAlertChangeOldNIP();
        }
    }

    startShake = () => {
        Platform.select({
            native: () => Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Heavy),
            default: () => {}
        })();

        Animated.sequence([
            Animated.timing(this.shakeAnimation, { toValue: 10, duration: 100, useNativeDriver: true }),
            Animated.timing(this.shakeAnimation, { toValue: -10, duration: 100, useNativeDriver: true }),
            Animated.timing(this.shakeAnimation, { toValue: 10, duration: 100, useNativeDriver: true }),
            Animated.timing(this.shakeAnimation, { toValue: 0, duration: 100, useNativeDriver: true })
        ]).start();
    }

    setFooter(){
        this.props.navigation.setOptions({
            tabBarVisible:false
        });
    }

    componentDidMount() {
        // https://www.w3.org/TR/service-workers-1/#dom-serviceworkerregistration-update
        // [sw] check for update when a NIP is asked
        // (not on NIP change but on creation/checks)
        const reg = getSwRegistration();
        if (reg && !this.isChange) {
          console.log("[sw] reg.update()")
          reg.update();
        }

        if(this.state.code.length>0){
            this.setState({
                code:"",
                attemptNIP : 0
            });
        }else{
            this.setState({
                attemptNIP : 0
            });
        }
        this.setFooter();
    }

    _deconnexion(){
        const action = {'type': 'SIGN_OUT', 'value':{}};
        this.props.dispatch(action);
        //this._navigateToConnexion();
    }

    _navigateToConnexion(){
        this.props.navigation.dispatch(
            CommonActions.reset({
                index: 1,
                routes: [
                    { name: 'Connexion' }
                ],
            })
        )
    }

    _navigateToHome(){
        //this.props.navigation.goBack();
    }

    _onValidateNIP(token) {
        this._signInNIP(token);

        // Update the cache when loging in
        // Dont if new update of SW:
        // cache updating will happen during this setup
	// FIXME: not called anymore!! When do you get latest content??
        if (! updateFound()) {
            console.log("[NIP] refreshing sw cache");
            preloadSw()
        }
    }

    async _sentEventConnect(){
        const url = "https://analytics.reticular.fr/api/event";
        console.log("sending event connect");
        const headers = {
            'Content-Type': 'application/json',
        }
        const body = {
            "name": "connect",
            "url": window.location.href,
            "domain": window.location.hostname,
            "props":{
                "email": this.props.auth.compte.email,
            }
        }
        await fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
        });
    }

    _enterNumber(number){
        Platform.select({
            native: () => Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Heavy),
            default: () => {}
        })();


        let code = this.state.code + number.toString();

        this.setState({
            code :code
        });

        if(code.length==4){
            if(this.props.NIP==null || this.state.etapeChangeNIP==1){
                // setting the NIP via redux will automatically refresh the whole tree
                // switching to a new view (home)
                this._createNIP(code)
            }else{

                if(this._verifNIP(code)){
                    this.setState({
                        code :""
                    });
                }else{
                    this.startShake();
                    this.setState({
                        code :""
                    });
                }
            }
        }
    }

    async _cryptNIP(token){
        let crypt  =  token
        return crypt;
    }

    async _createNIP(code){
        await this._sentEventConnect();
        let token  =code
        const action = {'type': 'SET_NIP', 'value':token};
        this.props.dispatch(action);
        this._signInNIP(token);
        this.setState({
            code :""
        });
        this._navigateToHome();
    }

    _signInNIP(token){
        const action = {'type': 'SIGN_IN_NIP', 'value':token};
        this.props.dispatch(action);
    }

    _sendAlertFailed(){
        alert(this.props.t('NIP erreur'));
        this._deconnexion();
    }
    _sendAlertNewNIP(){
        alert(this.props.t("Changer NIP"));
    }

    _sendAlertChangeOldNIP(){
        alert(this.props.t("Ancien NIP"))
    }

    _sendAlertChangenNewNIP(){
        alert(this.props.t("Nouveau NIP"))
    }

    _setAttemptNIP(attempt){
        const action = {'type': 'SET_ATTEMPT_NIP', 'value':attempt};
        this.props.dispatch(action);
    }

    async _verifNIP(code){

        let attempt = this.props.attemptNIP +1;
        let token  = await this._cryptNIP(code);
         if(token==this.props.NIP.token){
             if(this.isChange){
                this._sendAlertChangenNewNIP();
                 this._setAttemptNIP(0);
                this.setState({
                    etapeChangeNIP:1,

                })
             }else{
                 this._onValidateNIP(token);
             }
         }else{
             if(attempt >= 3){
                 this._sendAlertFailed();
             }
             this.startShake();
             this._setAttemptNIP(attempt);
             return false;
         }
    }

    _removeNumber(){
        let code = this.state.code.slice(0,-1);
        this.setState({
            code :code
        });
    }

    render() {
        const style = StyleSheet.create({
            droidSafeArea: {
                flex: 1,
                paddingTop: Platform.OS === 'android' ? 35 : 0,
                backgroundColor: this.props.theme.colors.primary.White.value
            },
            logo :{
                width:80,
                minHeight:100
            },
            logoContainer : {
                width:"100%",
                justifyContent:"center",
                alignItems:"center",
                flexDirection:"row",
                gap: 10,
                flex: 3
            },
            dotContainer : {
                flex:1,
                flexDirection:"row",
                justifyContent:"center",
                width:"100%",
                marginHorizontal:"auto",
                maxHeight:60,
                marginTop:-40
            },
            inputContainer : {
                flex : 5,
                flexDirection:"row",
                flexWrap:"wrap",
                justifyContent:"center",
                marginHorizontal:40,

            },
            deconnexionContainer : {
                flex:1,
                width:"100%",
                justifyContent:"center",
                alignItems:"center"
            },
            dot : {
                width : 18,
                height : 18,
                borderRadius:50,
                marginRight : 35
            },
            dotBlue  : {
                backgroundColor:this.state.code.length>0?  this.props.theme.colors.primary.blue2.value : this.props.theme.colors.tertiary.black11.value,
            },
            dotYellow : {
                backgroundColor:this.state.code.length>1?  this.props.theme.colors.secondary.yellow1.value : this.props.theme.colors.tertiary.black11.value,
            },
            dotGreen : {
                backgroundColor:this.state.code.length>2?  this.props.theme.colors.secondary.green2.value : this.props.theme.colors.tertiary.black11.value,
            },
            dotPink : {
                marginRight:0,
                backgroundColor:this.state.code.length>3?  this.props.theme.colors.secondary.pink2.value : this.props.theme.colors.tertiary.black11.value,
            },
            effacerPicto:{
                width:"33%",
                marginTop:45,
                //justifyContent:"center",
                alignItems:"center"

            },
            textTentative :{
                textAlign:"center",
                color : this.props.theme.colors.primary.error.value,
                fontFamily : this.props.theme.fonts.text,
                display : (this.props.attemptNIP > 0) ? "flex" : "none"
            },
            tentativeContainer : {
                marginVertical:10,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }
        });

        return (
            <SafeAreaView style={style.droidSafeArea}>
                <View style={style.logoContainer}>
                    <LogoComplet style={style.logo}/>
                    <BOLogoComplet style={style.logo} />
                </View>
                <Animated.View style={[style.dotContainer,{transform: [{translateX: this.shakeAnimation}]}]}>
                    <View style={[style.dot,style.dotBlue]}></View>
                    <View style={[style.dot,style.dotYellow]}></View>
                    <View style={[style.dot,style.dotGreen]}></View>
                    <View style={[style.dot,style.dotPink]}></View>
                </Animated.View>
                <View  style={style.tentativeContainer}>
                    <Text style={style.textTentative}>{this.props.t('Tentative NIP1')} {3-this.props.attemptNIP} {this.props.t('Tentative NIP2')}</Text>
                </View>
                <View style={style.inputContainer}>
                    <KeyboardNumber onPress={()=>this._enterNumber(1)} number={1}/>
                    <KeyboardNumber onPress={()=>this._enterNumber(2)} number={2}/>
                    <KeyboardNumber onPress={()=>this._enterNumber(3)} number={3}/>
                    <KeyboardNumber onPress={()=>this._enterNumber(4)} number={4}/>
                    <KeyboardNumber onPress={()=>this._enterNumber(5)} number={5}/>
                    <KeyboardNumber onPress={()=>this._enterNumber(6)} number={6}/>
                    <KeyboardNumber onPress={()=>this._enterNumber(7)} number={7}/>
                    <KeyboardNumber onPress={()=>this._enterNumber(8)} number={8}/>
                    <KeyboardNumber onPress={()=>this._enterNumber(9)} number={9}/>
                    <KeyboardNumber number={""}/>
                    <KeyboardNumber onPress={()=>this._enterNumber(0)} number={0}/>
                    <TouchableOpacity onPress={()=>this._removeNumber()}  style={style.effacerPicto}><EffacerPicto style={{width:25}} isHeader={true} /></TouchableOpacity>
                </View>
            </SafeAreaView>
        );
    }
}


const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme,tokenNIP : state.AuthReducer.tokenNIP,attemptNIP: state.AuthReducer.attemptNIP,NIP : state.AuthReducer.NIP,auth : state.AuthReducer};
}

export default compose(withTranslation(),connect(mapStateToProps))(NIPScreen);
